import React, { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux';
import moment from "moment"
import { SocketContext } from '../../../../context/socketContext';
import styles from "./styles.module.css";
import { useWindowDimensions } from "../../../../utils/util";
import { getConversations } from '../../../../store/actions/conversations';
import { getUser } from '../../../../store/actions/user/userAction';
import { addMessage, getMessages } from '../../../../store/actions/messages';
import { getTeacherDetailById } from '../../../../store/actions/teacher/index';
import { getStudentDetailById } from "../../../../store/actions/student/index"

//Pictures
import staticpic from "../../../../assets/icon/user.png"
import send from "../../../../assets/icon/icons8-send-32.png"
import search from "../../../../assets/icon/search-icon.svg"
import pinIcon from "../../../../assets/icon/pinIcon.png"
import { useContext } from 'react';
import { useLocation } from 'react-router-dom';

const Messages = () => {
  const adminId = "6220e5b15e6e8a82aff9a0b9"
  const location = useLocation()
  const socket = useContext(SocketContext);
  const [profilePic, setProfilePic] = useState(null)
  const [currUserId, setCurrUserId] = useState();
  const [conversations, setConversations] = useState();
  const [newMsg, setNewMsg] = useState("")
  const [othersDetails, setOthersDetails] = useState(null);
  const [currentChat, setCurrentChat] = useState(null);

  const [messages, setMessages] = useState();
  const [arrivalMessage, setArrivalMessage] = useState(null);
  const [userRole, setUserRole] = useState("")
  const [chatMobileClick, setChatMobileClick] = useState(false)
  const { width } = useWindowDimensions();
  const scrollRef = useRef()
  const dispatch = useDispatch()

  useEffect(() => {
    if (!socket) return;
    socket.on("getMessage", (data) => {
      console.log("📨 Message received via socket:", data);
      setArrivalMessage({
        senderId: data.senderId, // Matches property used in messages state
        message: data.message,
        createdAt: Date.now(),
      });
    });
    return () => {
      socket.off("getMessage");
    };
  }, [socket]);

  useEffect(() => {
    if (arrivalMessage && currentChat?.members) {
      const isRelevant = currentChat.members.some(member => String(member) === String(arrivalMessage.senderId));
      if (isRelevant) {
        setMessages((prev) => [...prev, arrivalMessage]);
      }
    }
  }, [arrivalMessage, currentChat]);

  // Fetching Current User Id
  useEffect(() => {
    let userProfile = JSON.parse(window.localStorage.getItem("profile"));
    socket?.on("getUsers", users => {
    })
    setCurrUserId(userProfile?._id)
    setUserRole(userProfile?.roleModel)
  }, [socket])

  // Fetching Conversations
  useEffect(() => {
    async function getConvs() {
      try {
        const res = await dispatch(getConversations(currUserId));
        console.log("🔍 Conversations API Response:", res);
        console.log("🔍 Response type:", typeof res, "Is Array:", Array.isArray(res));

        // Check if res is an array
        if (!res || !Array.isArray(res)) {
          console.error("❌ Conversations response is not an array:", res);
          setConversations([]);
          return;
        }

        console.log("✅ Number of conversations:", res.length);

        // Group by participant pairs to avoid showing redundant conversations for ALL users
        const uniquePairs = new Map();
        res.forEach(c => {
          console.log("📝 Processing conversation:", c);
          const pairKey = c.members ? [...c.members].sort().join("_") : c._id;
          if (!uniquePairs.has(pairKey)) {
            uniquePairs.set(pairKey, c);
          }
        });

        const finalConversations = Array.from(uniquePairs.values());
        console.log("✅ Final conversations to display:", finalConversations);
        setConversations(finalConversations);
      } catch (err) {
        console.error("❌ Error fetching conversations:", err);
      }
    }
    if (currUserId) getConvs();
  }, [currUserId, dispatch, userRole, adminId]);

  // Fetching Messages
  useEffect(() => {
    async function getMsgs() {
      try {
        const res = await dispatch(getMessages(currentChat?._id));
        setMessages(res || []);
      } catch (err) {
        console.error(err)
      }
    }
    if (currentChat?._id) {
      getMsgs();
    }
  }, [currentChat, dispatch])

  // Profile pic is now set in handleChatClick from memberDetails
  // Keeping this as a fallback for when memberDetails doesn't have profilePic
  useEffect(() => {
    // Only fetch if we have othersDetails but no profilePic
    if (othersDetails && !profilePic) {
      async function getTPP() {
        try {
          const res = await dispatch(getTeacherDetailById(othersDetails?._id))
          setProfilePic(res?.[0]?.teacherProfilePic?.data || res?.[0]?.teacherProfilePic)
        } catch (err) {
          console.error(err)
        }
      }

      async function getSPP() {
        try {
          const res = await dispatch(getStudentDetailById(othersDetails?._id))
          setProfilePic(res?.[0]?.profilePic?.data || res?.[0]?.profilePic)
        } catch (err) {
          console.error(err)
        }
      }

      if (othersDetails?.roleModel === "Student") {
        getSPP()
      } else if (othersDetails?.roleModel === "Teacher") {
        getTPP()
      }
    }


  }, [othersDetails, profilePic, dispatch])

  // Handle Chat Click
  const handleChatClick = React.useCallback(async (ch) => {
    if (!ch || !ch.members) {
      console.warn("Invalid chat object passed to handleChatClick:", ch);
      return;
    }
    setCurrentChat(ch)
    setChatMobileClick(true)

    // Use memberDetails from the conversation if available
    if (ch?.memberDetails && ch.memberDetails.length > 0) {
      // For Admin, we might want to show both participants
      // For regular users, show the OTHER person
      const othersId = ch?.members.find((m) => m !== currUserId) || ch?.members[0]
      const otherMemberDetail = ch.memberDetails.find(md => md.userId === othersId)

      if (otherMemberDetail) {
        // Map memberDetails to the format expected by othersDetails
        setOthersDetails({
          _id: otherMemberDetail.userId,
          fullName: otherMemberDetail.name,
          email: otherMemberDetail.email,
          roleModel: otherMemberDetail.role,
          profilePic: otherMemberDetail.profilePic
        })
        setProfilePic(otherMemberDetail.profilePic)
        return
      }
    }

    // Fallback to old method if memberDetails not available
    const othersId = ch?.members?.find((m) => String(m) !== String(currUserId)) || ch?.members?.[0]
    try {
      const res = await dispatch(getUser(othersId));
      setOthersDetails(res)
    } catch (err) {
      console.error(err)
    }
  }, [currUserId, dispatch])

  // Handle send Button Click
  const sendMessage = async (e) => {
    e.preventDefault();
    if (!newMsg.trim()) return;

    if (!currentChat || !currentChat.members) {
      console.error("Cannot send message: Invalid currentChat state", currentChat);
      return;
    }

    const msgObj = {
      senderId: currUserId,
      message: newMsg,
      conversationId: currentChat._id,
    }

    // Safety check for members
    const receiverId = currentChat.members.find((m) => String(m) !== String(currUserId));

    if (!receiverId) {
      console.error("Cannot determine receiverId from members", currentChat.members);
      // Optionally alert user or handle error
      return;
    }

    socket?.emit("sendMessage", {
      senderId: currUserId,
      receiverId,
      message: newMsg,
      role: userRole,
    })

    socket?.emit("sendNotification", {
      senderId: currUserId,
      receiverId,
      role: userRole,
    })

    try {
      const response = await dispatch(addMessage(msgObj))
      setMessages([...messages, response])
      setNewMsg("")
    } catch (error) {
      console.error(error)
    }
  }

  //open chat directly from student current teacher 
  useEffect(() => {

    if (location.pathname === "/student/messages") {
      handleChatClick(location.state?.cchat)
    }
  }, [location, handleChatClick])

  //Automatic scroll
  useEffect(() => {
    scrollRef.current?.scrollIntoView({ block: "nearest", behaviour: "smooth" })
  }, [messages])

  let color = {
    msWrapper: userRole === "Student" ? "#FECDE6" : "#9ECDE6",
    msHead: userRole === "Student" ? "#fb698e" : "#3eaeea",
    msMsg: userRole === "Student" ? "#ff97b1" : "#3a9fd5",
    msSearch: userRole === "Student" ? "#fcb1c4" : "#76bbe0",
  }


  return (
    <>
      <main className={styles.mainSection}>
        {width >= 992 ? (
          <div className={styles.mainWrapper}>
            {/* MessageSection */}
            <div className={styles.MS_wrapper} style={{ backgroundColor: color.msWrapper }}>
              {
                currentChat ? <>
                  {/* Name of the Chat  */}
                  <div className={styles.MS_head} style={{ backgroundColor: color.msHead }}>
                    <div className={styles.MS_head_left}>
                      <img src={profilePic ? profilePic : staticpic} alt="" style={{ width: "30px", height: "30px", borderRadius: "50%", backgroundColor: "#fff" }} />
                      <div className={styles.MS_studentName}>{othersDetails?.fullName}</div>
                    </div>
                    {userRole === "Admin" ?
                      <div className={styles.MS_head_right}>
                        id: {othersDetails?._id}
                      </div> : null}
                  </div>
                  <div className={userRole === "Teacher" ? styles.MS_msgs : styles.MS_msgsStudent}> {/* Doing this for scroll bar color */}
                    {messages?.map((item) => {
                      return (
                        <div ref={scrollRef} className={styles.MSG_container} style={{ alignSelf: item.senderId === currUserId ? "flex-end" : "" }}>
                          <Msg text={item.message} time={moment(item.createdAt).format("MMM DD, h:mm A")} ownMsg={item.senderId === currUserId} color={color} />
                        </div>
                      )
                    })}
                  </div>
                  {userRole !== "Admin" ? (
                    <form onSubmit={(e) => sendMessage(e)} className={styles.MS_in}>
                      <input type="text" name="sendMsg" className={styles.MS_inMsg} style={{ backgroundColor: color.msSearch }} value={newMsg} placeholder="Type your message here" onChange={(e) => setNewMsg(e.target.value)} />
                      <button type='submit' className={styles.MS_sendBtn} style={{ backgroundColor: color.msMsg }} >
                        <img src={send} alt="" />
                      </button>
                    </form>
                  ) : (
                    <div className={styles.adminRestrictionNote}>Admin Mode: Read-only access</div>
                  )}
                </> :
                  <>
                    <div className={styles.MS_nochat}>Open a conversation to start Chatting.</div>
                  </>
              }
            </div>

            {/* AllChats */}
            <div className={styles.AC_wrapper} style={{ backgroundColor: color.msWrapper }}>
              <div className={styles.AC_heading} style={{ backgroundColor: color.msHead }}>All Chats</div>
              <div className={styles.AC_search}>
                <input type="text" name="searchChats" placeholder='Search' className={styles.AC_searchIn} style={{ backgroundColor: color.msSearch }} />
                <img src={search} alt="" className={styles.AC_searchIcon} />
              </div>
              <div className={styles.AC_results}>
                {conversations && conversations.length > 0 ? (
                  conversations.map((item) => (
                    <div key={item._id} onClick={() => handleChatClick(item)}>
                      <ACField
                        conversation={item}
                        currentUser={currUserId}
                        userRole={userRole}
                        color={color}
                        adminId={adminId}
                      />
                    </div>
                  ))
                ) : (
                  <div style={{ padding: "20px", textAlign: "center", color: "#666" }}>
                    {conversations === undefined ? "Loading conversations..." : "No conversations yet"}
                  </div>
                )}
              </div>
            </div>

          </div>
        ) : (
          <div className={styles.mainWrapper}>


            {!chatMobileClick ? (
              /* AllChats */
              <div className={styles.AC_wrapper} style={{ backgroundColor: color.msWrapper }}>
                <div className={styles.AC_heading} style={{ backgroundColor: color.msHead }}>All Chats</div>
                <div className={styles.AC_search}>
                  <input type="text" name="searchChats" placeholder='Search' className={styles.AC_searchIn} style={{ backgroundColor: color.msSearch }} />
                  <img src={search} alt="" className={styles.AC_searchIcon} />
                </div>
                <div className={styles.AC_results}>
                  {conversations && conversations.length > 0 ? (
                    conversations.map((item) => (
                      <div key={item._id} onClick={() => handleChatClick(item)}>
                        <ACField
                          conversation={item}
                          currentUser={currUserId}
                          userRole={userRole}
                          color={color}
                          adminId={adminId}
                        />
                      </div>
                    ))
                  ) : (
                    <div style={{ padding: "20px", textAlign: "center", color: "#666" }}>
                      {conversations === undefined ? "Loading conversations..." : "No conversations yet"}
                    </div>
                  )}
                </div>
              </div>) :
              /* MessageSection */
              < div className={styles.MS_wrapper} style={{ backgroundColor: color.msWrapper }}>
                {
                  currentChat ? <>
                    {/* Name of the Chat  */}
                    <div className={styles.MS_head} style={{ backgroundColor: color.msHead }}>
                      <div className={styles.MS_head_left}>
                        <div className="MS_backbtn" onClick={() => setChatMobileClick(false)}>
                          <i class="fa-solid fa-arrow-left"></i>
                        </div>
                        <img src={profilePic ? profilePic : staticpic} alt="" style={{ width: "30px", height: "30px", borderRadius: "50%", backgroundColor: "#fff" }} />
                        <div className={styles.MS_studentName}>{othersDetails?.fullName}</div>
                      </div>
                      {userRole === "Admin" ?
                        <div className={styles.MS_head_right}>
                          id: {othersDetails?._id}
                        </div> : null}
                    </div>
                    <div className={userRole === "Teacher" ? styles.MS_msgs : styles.MS_msgsStudent}> {/* Doing this for scroll bar color */}
                      {messages?.map((item) => {
                        return (
                          <div ref={scrollRef} className={styles.MSG_container} style={{ alignSelf: item.senderId === currUserId ? "flex-end" : "" }}>
                            <Msg text={item.message} time={moment(item.createdAt).format("MMM DD, h:mm A")} ownMsg={item.senderId === currUserId} color={color} />
                          </div>
                        )
                      })}
                    </div>
                    {userRole !== "Admin" ? (
                      <form onSubmit={(e) => sendMessage(e)} className={styles.MS_in}>
                        <input type="text" name="sendMsg" className={styles.MS_inMsg} style={{ backgroundColor: color.msSearch }} value={newMsg} placeholder="Type your message here" onChange={(e) => setNewMsg(e.target.value)} />
                        <button type='submit' className={styles.MS_sendBtn} style={{ backgroundColor: color.msMsg }} >
                          <img src={send} alt="" />
                        </button>
                      </form>
                    ) : (
                      <div className={styles.adminRestrictionNote}>Admin Mode: Read-only access</div>
                    )}
                  </> :
                    <>
                      <div className={styles.MS_nochat}>Open a conversation to start Chatting.</div>
                    </>
                }
              </div>
            }



          </div>
        )
        }

      </main>
    </>
  )
}

const Msg = ({ text, time, ownMsg, color }) => {
  return (

    <div className={styles.MSG_wrapper}>
      <div className={styles.MSG_msg} style={{ backgroundColor: ownMsg ? color.msMsg : "#fff" }}>
        {text}
      </div>
      <div className={styles.MSG_time}>
        {time}
      </div>
    </div>

  )
}

const ACField = ({ conversation, currentUser, userRole, color, adminId }) => {
  const isViewerAdmin = userRole === "Admin" || currentUser === adminId;

  // Use memberDetails from conversation if available, otherwise use members array
  const getDisplayNames = () => {
    console.log("🔍 ACField conversation:", conversation);

    // Use enriched memberDetails from backend if available
    if (conversation.memberDetails && conversation.memberDetails.length > 0) {
      console.log("✅ Using memberDetails:", conversation.memberDetails);
      if (isViewerAdmin) {
        // Show all participants for admin
        return conversation.memberDetails
          .map(md => md.name)
          .filter(Boolean)
          .filter((val, idx, self) => self.indexOf(val) === idx)
          .join(" & ");
      }

      // For regular users, show the OTHER person
      const otherMember = conversation.memberDetails.find(
        md => md && String(md.userId) !== String(currentUser)
      );
      return otherMember?.name || "Chat Partner";
    }

    // Fallback if memberDetails not available - show member IDs
    console.warn("⚠️ memberDetails not available, using fallback");
    if (conversation.members && conversation.members.length > 0) {
      if (isViewerAdmin) {
        return conversation.members.join(" & ");
      }
      const otherId = conversation.members.find(m => String(m) !== String(currentUser));
      return otherId || "Unknown";
    }


    return "Loading...";
  };

  const displayNames = getDisplayNames();

  // Determine background color based on participant roles
  const getBackgroundColor = () => {
    if (isViewerAdmin && conversation.memberDetails) {
      const hasTeacher = conversation.memberDetails.some(md => md?.role === "Teacher");
      return hasTeacher ? "#3eaeea" : "#ff97b1";
    }
    return color.msMsg;
  };

  const hasAdmin = conversation.memberDetails?.some(md => md?.role === "Admin");

  return (
    <>
      <div className={styles.AC_field} style={{ backgroundColor: getBackgroundColor() }}>
        {displayNames}
        {hasAdmin && <img src={pinIcon} alt="pin" />}
      </div>
    </>
  )
}

export default Messages
